import { render, staticRenderFns } from "./CompanySdsRevisionCopyFieldsForm.vue?vue&type=template&id=26ed7a23&scoped=true"
import script from "./CompanySdsRevisionCopyFieldsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySdsRevisionCopyFieldsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySdsRevisionCopyFieldsForm.vue?vue&type=style&index=0&id=26ed7a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed7a23",
  null
  
)

export default component.exports